import { Domain } from '~/types/axis.types';
import { CreateChartOptionsWithColors, XAxis } from '~/types/create.types';
import { TsDataPoint } from '~/types/timeseries.types';

import { calculateDataRange } from './y-scale/y-scale';

interface GetVisibleRangeProps {
  options: CreateChartOptionsWithColors;
  x: XAxis;
  barSpacing: number;
}

export const getVisibleRange = ({
  options,
  x,
  barSpacing,
}: GetVisibleRangeProps): Domain => {
  const newBarsLength = (options.width - options.gutters.y) / barSpacing;
  const rightBorder = x.latestTickIndex;
  const leftBorder = rightBorder - newBarsLength + 1;
  // TODO math max
  const leftBorderMinimum = leftBorder < 0 ? 0 : Math.floor(leftBorder);
  return [leftBorderMinimum, Math.ceil(rightBorder)];
};

interface RangeIndexToYCoordinateProps {
  data: TsDataPoint[];
  startIndex: number;
  endIndex: number;
}

export const rangeIndexesToYCoordinate = ({
  data,
  startIndex,
  endIndex,
}: RangeIndexToYCoordinateProps) => {
  // TODO maybe refactor as this can be expensive on big domains (ran every time a new scroll, potentially hundreds/thousands of times a minute)
  const slicedData = data.slice(startIndex, endIndex + 1);
  const range = calculateDataRange(slicedData, 'value');
  return range;
};
